import { render } from "./FlowBlueprintFormDialog.vue?vue&type=template&id=52085777"
import script from "./FlowBlueprintFormDialog.vue?vue&type=script&lang=js"
export * from "./FlowBlueprintFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__